import { LogOut } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export function LogoutButton() {
  const navigate = useNavigate()

  const handleLogout = async () => {
    try {
      await fetch(`${import.meta.env.VITE_BACKEND_URL}/logout`, {
        method: 'POST',
        credentials: 'include'
      })
      navigate('/')
    } catch (err) {
      console.error('Logout error:', err)
    }
  }

  return (
    <button onClick={handleLogout} className="logout-btn">
      <span className="logout-text">Cerrar sesión</span>
      <LogOut size={20} />
    </button>
  )
}
